import { render, staticRenderFns } from "./VlFile.vue?vue&type=template&id=63e7882a&"
import script from "./VlFile.vue?vue&type=script&lang=js&"
export * from "./VlFile.vue?vue&type=script&lang=js&"
import style0 from "./VlFile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports